var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 72,
    viewBox: "0 0 80 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3398 46.3423C76.9912 46.0628 76.6275 45.8041 76.25 45.5667V0.84375H20V40.3359C19.0273 41.0133 18.6861 41.3467 16.7719 43.0312H0V71.1562H17.6562H20H53.5977L80 50.5614C79.6105 48.8922 78.677 47.4145 77.3398 46.3423ZM15.3125 66.4688H4.6875V47.7188H15.3125V66.4688ZM43.4375 5.53125H52.8125V19.5938H43.4375V5.53125ZM38.75 5.53125V24.2812H57.5V5.53125H71.5625V43.8737C68.7553 43.4952 65.9333 44.1353 63.5522 45.7036L56.3414 50.4536C57.0836 48.9162 57.5 47.1933 57.5 45.375V43.0312H42.8625C41.7841 43.0312 41.3077 42.4411 40.2133 41.4783C35.8636 37.6505 29.9586 36.5212 24.6875 38.0828V5.53125H38.75ZM52.0273 66.4688H20V46.4345L21.6333 44.9972C26.0467 41.1133 32.7033 41.1133 37.1167 44.9972C38.3162 46.0527 39.8809 47.6873 42.8625 47.6873H52.4108C51.4436 50.4156 48.8369 52.4061 45.7811 52.4061H36.4061V57.0936H54.7817L66.1306 49.6178C68.652 47.9572 71.8242 48.1078 74.1322 49.7855L52.0273 66.4688Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility16);
export default __webpack_public_path__ + "static/media/gefion-facility-16.bcdc1b0f.svg";
export { ForwardRef as ReactComponent };